/**
 * CLDR JavaScript Library v0.5.4
 * http://jquery.com/
 *
 * Copyright 2013 Rafael Xavier de Souza
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2020-10-22T15:56Z
 */

/*!
 * CLDR JavaScript Library v0.5.4 2020-10-22T15:56Z MIT license © Rafael Xavier
 * http://git.io/h4lmVg
 */
(function (factory) {
  if (typeof define === "function" && define.amd) {
    // AMD.
    define(["../cldr"], factory);
  } else if (typeof module === "object" && typeof module.exports === "object") {
    // Node. CommonJS.
    module.exports = factory(require("../cldr"));
  } else {
    // Global
    factory(Cldr);
  }
})(function (Cldr) {
  // Build optimization hack to avoid duplicating functions across modules.
  var alwaysArray = Cldr._alwaysArray;

  var supplementalMain = function supplementalMain(cldr) {
    var prepend, supplemental;

    prepend = function prepend(_prepend) {
      return function (path) {
        path = alwaysArray(path);
        return cldr.get([_prepend].concat(path));
      };
    };

    supplemental = prepend("supplemental"); // Week Data
    // http://www.unicode.org/reports/tr35/tr35-dates.html#Week_Data

    supplemental.weekData = prepend("supplemental/weekData");

    supplemental.weekData.firstDay = function () {
      return cldr.get("supplemental/weekData/firstDay/{territory}") || cldr.get("supplemental/weekData/firstDay/001");
    };

    supplemental.weekData.minDays = function () {
      var minDays = cldr.get("supplemental/weekData/minDays/{territory}") || cldr.get("supplemental/weekData/minDays/001");
      return parseInt(minDays, 10);
    }; // Time Data
    // http://www.unicode.org/reports/tr35/tr35-dates.html#Time_Data


    supplemental.timeData = prepend("supplemental/timeData");

    supplemental.timeData.allowed = function () {
      return cldr.get("supplemental/timeData/{territory}/_allowed") || cldr.get("supplemental/timeData/001/_allowed");
    };

    supplemental.timeData.preferred = function () {
      return cldr.get("supplemental/timeData/{territory}/_preferred") || cldr.get("supplemental/timeData/001/_preferred");
    };

    return supplemental;
  };

  var initSuper = Cldr.prototype.init;
  /**
   * .init() automatically ran on construction.
   *
   * Overload .init().
   */

  Cldr.prototype.init = function () {
    initSuper.apply(this, arguments);
    this.supplemental = supplementalMain(this);
  };

  return Cldr;
});